import { Calculator, Percent, ChartLine, CurrencyDollar, TrendUp } from "@phosphor-icons/react";

export const calculators = [
  {
    slug: "crypto-tax-calculator-india",
    title: "Crypto Tax Calculator India",
    shortTitle: "Crypto Tax Calculator",
    shortDesc: "Calculate your crypto tax liability under Section 115BBH. Input your buy price, sell price, and quantity to get your exact tax obligation.",
    icon: Calculator,
    seoTitle: "Crypto Tax Calculator India | Section 115BBH Tax Calculator 2026",
    seoDesc: "Free crypto tax calculator for India. Calculate your 30% tax liability on crypto gains under Section 115BBH. Includes surcharge, health & education cess, and advance tax estimation.",
    tags: ["crypto tax calculator india", "115bbh calculator", "crypto gain tax calculator", "bitcoin tax india", "crypto tax calculator free"],
  },
  {
    slug: "crypto-tds-calculator",
    title: "Crypto TDS Calculator",
    shortTitle: "TDS Calculator",
    shortDesc: "Calculate the 1% TDS applicable on your crypto transactions under Section 194S. Know your deduction amount before you trade.",
    icon: Percent,
    seoTitle: "Crypto TDS Calculator India | Section 194S TDS Calculator 2026",
    seoDesc: "Free crypto TDS calculator for India. Calculate 1% TDS on crypto transactions under Section 194S. Know your TDS deduction before buying or selling crypto.",
    tags: ["crypto tds calculator", "194s tds calculator", "1% tds crypto", "tds on cryptocurrency india", "vda tds calculator"],
  },
  {
    slug: "crypto-profit-loss-calculator",
    title: "Crypto Profit & Loss Calculator",
    shortTitle: "Profit/Loss Calculator",
    shortDesc: "Calculate your net profit or loss from any crypto trade. Includes fee deduction and percentage return calculation.",
    icon: ChartLine,
    seoTitle: "Crypto Profit Calculator | Bitcoin Profit & Loss Calculator 2026",
    seoDesc: "Free crypto profit and loss calculator. Calculate your gains or losses from Bitcoin, Ethereum, and any crypto trade. Includes trading fees, percentage return, and tax impact for India.",
    tags: ["crypto profit calculator", "bitcoin profit calculator", "crypto gain loss calculator", "crypto roi calculator", "ethereum profit calculator"],
  },
  {
    slug: "crypto-staking-rewards-calculator",
    title: "Crypto Staking Rewards Calculator",
    shortTitle: "Staking Calculator",
    shortDesc: "Estimate your crypto staking rewards based on amount, APY, and duration. See your earnings before and after Indian tax.",
    icon: CurrencyDollar,
    seoTitle: "Crypto Staking Calculator | Staking Rewards & APY Calculator 2026",
    seoDesc: "Free crypto staking rewards calculator. Estimate your staking earnings based on amount, APY, and duration. Includes tax impact calculation under Indian Section 115BBH.",
    tags: ["crypto staking calculator", "staking rewards calculator", "staking apy calculator", "ethereum staking calculator", "crypto yield calculator"],
  },
  {
    slug: "crypto-sip-calculator",
    title: "Crypto SIP Calculator",
    shortTitle: "SIP Calculator",
    shortDesc: "Calculate potential returns from systematic crypto investment (SIP). See how regular, disciplined investing in crypto can grow over time.",
    icon: TrendUp,
    seoTitle: "Crypto SIP Calculator India | Bitcoin SIP Returns Calculator 2026",
    seoDesc: "Free crypto SIP calculator. Calculate potential returns from systematic investment in Bitcoin, Ethereum, or any crypto. See monthly, yearly, and long-term growth projections.",
    tags: ["crypto sip calculator", "bitcoin sip calculator", "systematic crypto investment", "crypto monthly investment calculator", "crypto dca calculator"],
  },
];

export const getCalculatorBySlug = (slug) => calculators.find(c => c.slug === slug);
